import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IBasePopupModel } from '../../models/popup.model';
import { BasePopupComponent } from '../base-popup/base-popup.component';

@Component({
    selector: 'app-delete-account-popup',
    standalone: false,
    templateUrl: './delete-account-popup.component.html',
    styleUrl: './delete-account-popup.component.scss',
})
export class DeleteAccountPopupComponent extends BasePopupComponent {
    protected title: string = 'Close Account?';
    protected message: string = 'Are you sure you want to delete your account? This action cannot be undone.';
    protected confirmButtonLabel: string = 'Delete';
    protected cancelButtonLabel: string = 'Keep Account';

    constructor(
        @Inject(MAT_DIALOG_DATA) protected override data: IBasePopupModel,
        protected override dialogRef: MatDialogRef<DeleteAccountPopupComponent>,
    ) {
        super(data, dialogRef);
    }
}
